import { render, staticRenderFns } from "./WPHeader.vue?vue&type=template&id=d71ebad4"
import script from "./WPHeader.vue?vue&type=script&lang=ts"
export * from "./WPHeader.vue?vue&type=script&lang=ts"
import style0 from "./WPHeader.vue?vue&type=style&index=0&id=d71ebad4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports